import { Trans, useTranslation } from 'react-i18next';
import { WithForm } from 'src/shared/HOC/WithForm';
import { Button, InputAdornment, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { ModalTitleWrapper } from './styles';
import { useGetCompaniesQuery, useUpdateSelfFundingLowOnFundsThresholdMutation } from 'src/shared/api/company';
import { type Company, type SelfFundedAccount } from 'src/shared/types/company';
import { Step } from 'src/modules/SaldoView/components/CompanySelectorBar/components/Step';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { noop } from 'lodash';
import { Form } from 'react-final-form';
import { parseLocaleNumber, formatCurrency } from 'src/shared/hooks/useCurrencyMask';
import { TextField } from 'mui-rff';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';

export type UpdateAlertModalProp = {
  closeModal: () => void;
  selectedCompanyId: string;
  account: SelfFundedAccount;
};

export const UpdateAlertModal = ({ closeModal, selectedCompanyId, account }: UpdateAlertModalProp) => {
  const { t } = useTranslation('overview');
  const { data: companies } = useGetCompaniesQuery();
  const [update] = useUpdateSelfFundingLowOnFundsThresholdMutation();

  // todo
  const handleSave = async (values: any) => {
    console.log(values);
    await update({
      companyId: selectedCompanyId,
      lowOnFundsThreshold: parseLocaleNumber(values.limit) ?? 0
    });
    closeModal();
  };

  return (
    <Grid2>
      <ModalTitleWrapper>{t('self funding.configure alert')}</ModalTitleWrapper>
      <Typography mb={2} sx={{ textAlign: 'left' }}>
        <Trans i18nKey={'self funding.configure alert description'} ns="overview" />
      </Typography>
      <Form
        onSubmit={handleSave}
        initialValues={{
          limit: account.lowOnFundsThreshold
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Grid2>
              <Step
                step={<NotificationsNoneIcon sx={{ position: 'relative', top: 2 }} />}
                title="self funding.add limit step description"
              >
                <TextField
                  name="limit"
                  label={t('field.balance limit')}
                  InputProps={{
                    style: { width: '100%' },
                    startAdornment: <InputAdornment position="start">€</InputAdornment>
                  }}
                  fieldProps={{
                    format: formatCurrency
                  }}
                />
              </Step>
            </Grid2>
            <Grid2 mt={2} sx={{ textAlign: 'right' }}>
              <Button variant="text" onClick={closeModal}>
                {t('cancel', { ns: 'common' })}
              </Button>
              <Button onClick={handleSubmit} type="submit" variant="contained">
                {t('save', { ns: 'common' })}
              </Button>
            </Grid2>
          </>
        )}
      </Form>
    </Grid2>
  );
};
